import {
  startOfMonth,
  endOfMonth,
  startOfDay,
  endOfDay,
  isSameDay,
} from 'date-fns'

const weekDayNames = ['do', 'se', 'te', 'qu', 'qu', 'se', 'sa']

const generateDates = (month: number, year: number) => {
  const firstDateOfMonth = startOfMonth(new Date(year, month))
  const lastDateOfMonth = endOfMonth(new Date(year, month))

  const arrayOfDate = []

  // create prefix date
  const prefixDays = firstDateOfMonth.getDay()
  for (let i = 0; i < prefixDays; i += 1) {
    const date = new Date(firstDateOfMonth)
    date.setDate(firstDateOfMonth.getDate() - prefixDays + i)

    arrayOfDate.push({
      isOnCurrentMonth: false,
      date: startOfDay(date),
    })
  }

  // generate current date
  for (
    let i = startOfDay(firstDateOfMonth).getDate();
    i <= endOfDay(lastDateOfMonth).getDate();
    i += 1
  ) {
    arrayOfDate.push({
      isOnCurrentMonth: true,
      date: startOfDay(new Date(year, month, i)),
      today: isSameDay(new Date(year, month, i), new Date()),
    })
  }

  const remaining = 42 - arrayOfDate.length

  for (
    let i = endOfDay(lastDateOfMonth).getDate() + 1;
    i <= endOfDay(lastDateOfMonth).getDate() + remaining;
    i += 1
  ) {
    arrayOfDate.push({
      isOnCurrentMonth: false,
      date: endOfDay(new Date(year, month, i)),
    })
  }
  return arrayOfDate as []
}

export { weekDayNames, generateDates }
